/**
 * 多列对称
 * @param {number} length 长度
 * @param {number} colNum 列数
 * @returns {[]}
 */
export function symmetry(length, colNum) {
  if (!length || !colNum) return [];
  const over = length % colNum;
  const add = Math.floor(over / 2);
  const isEven = !(over % 2);
  const mid = Math.floor(colNum / 2);
  return Array(colNum)
    .fill(0)
    .map((e, i) => {
      if (over === 0) return e;
      if (isEven && (i < add || (i + add) % colNum < add)) return 1;
      if (!isEven && i >= mid - add && i <= mid + add) return 1;
      return e;
    });
}

/**
 * 多列排序
 * @param {number} len
 * @param {number} row
 * @param {number} col
 * @returns {[][]} 多列横向排序
 */
export function colsSort(len, col) {
  if (len === 0) return null;
  const row = Math.floor(len / col);
  const makeArr = num =>
    Array(num)
      .fill(0)
      .map((_, i) => i);
  const rows = makeArr(row);
  const cols = makeArr(col);
  return cols.map(a => {
    return rows.map(b => b * col + a);
  });
}
